import { Component, ElementRef, inject, input, ViewChild } from "@angular/core";
import { MarkdownComponent, MarkdownModule } from "ngx-markdown";
import { ProgressSpinnerModule } from "primeng/progressspinner";
import { FloatingAssistantChatService } from "src/app/common/services/floating-assistant-chat.service";
import { PillarboxService } from "src/app/common/services/pillarbox.service";
import { copyHtmlOfElement } from "src/app/common/tools/copyHtmlOfElement";

@Component({
  standalone: true,
  templateUrl: "./documents-space-chat-line.component.html",
  imports: [ProgressSpinnerModule, MarkdownModule],
  selector: "app-documents-space-chat-line",
  styleUrls: ["./documents-space-chat-line.component.scss"],
})
export class DocumentsSpaceChatLineComponent {
  readonly content = input.required<string>();
  readonly username = input.required<string>();
  readonly readonly = input(false);

  @ViewChild(MarkdownComponent, { read: ElementRef }) markdownZone!: ElementRef;
  protected readonly floatingAssistantChatService = inject(FloatingAssistantChatService);
  protected readonly pillarboxService = inject(PillarboxService);
  protected readonly copyHtmlOfElement = copyHtmlOfElement;

  get usernameString(): string {
    const username = this.username();
    switch (username) {
      case "assistant":
        return $localize`:@@chat_line_assistant_name:Assistant`;
      case "user":
        return $localize`:@@chat_line_user_name:Vous`;
      case "system":
        return $localize`:@@chat_line_system_name:Contexte`;
      default:
        return username;
    }
  }
}
